// Data pegawai LLDIKTI Wilayah VII dikelompokkan menurut kolom "Tim Kerja"
// pada berkas Daftar Pegawai. Urutan grup mengikuti permintaan resmi.
// Dipakai pada halaman "Pengelolaan Kepegawaian" (Data dan Laporan).

export const KEPEGAWAIAN_GROUPS = [
  {
    slug: "kepala",
    label: "Kepala",
    names: ["Dyah Sawitri"],
  },
  {
    slug: "kepala-bagian-umum",
    label: "Kepala Bagian Umum",
    names: ["Muhammad Machmud"],
  },
  {
    slug: "akademik-dan-risbang",
    label: "Akademik dan Risbang",
    names: [
      "Mayastuti",
      "Afif Afifaturosyidah",
      "Dara Adhelia Yoedhistira",
      "Eko Juli Kusumawardana",
      "Imanuel Eka Prakasa",
      "Josef Sandy Sutejo",
      "Kadek Anggi Sastra Pramana",
      "M. Mu'izzuddin",
      "Rina Indrawati",
      "Wahyu Amri Yahya",
    ],
  },
  {
    slug: "kelembagaan-dan-kerja-sama",
    label: "Kelembagaan Dan Kerja Sama",
    names: [
      "Ratna Dwi Anggarwati",
      "Airin Nurfattma",
      "Dhani Kusuma Wardhana",
      "Farida Ulfayatin",
      "Hariyono",
      "Joko Susilo",
      "Lina Arifatul Hidayah",
      "Soetjahyono",
      "Swastika Maya Pramesti",
      "Wening Ros Indri Puji Saputro",
    ],
  },
  {
    slug: "kemahasiswaan",
    label: "Kemahasiswaan",
    names: [
      "Agung Yundi Bahuda Sistawan",
      "Amalia Wahyuningtyas",
      "Arba'i",
      "Bayuk Nur A'yun",
      "Hotlan Simanulang",
      "Prayogi Hartono",
      "Sagung Puteri Santiara Dewi",
      "Farida Ulfayatin",
    ],
  },
  {
    slug: "hukum-kepegawaian-dan-tata-laksana",
    label: "Hukum Kepegawaian dan Tata Laksana",
    names: [
      "Etis Ana Safitri",
      "Arif Hendrawan",
      "Ganis Larasati",
      "Lea Wijayanti",
      "Masyudi Hendra Kurniawan",
      "Rossi Arisdiawan",
      "Siswanto",
      "Slamet Abdul Salim",
      "Suprianto",
      "Winda Hayu Rahmawati",
      "Zahro Lasarik",
    ],
  },
  {
    slug: "keuangan",
    label: "Keuangan",
    names: [
      "Raden Erdianto Setyo Wahyono",
      "Dewita Putri Mentari",
      "Dhidit Prasetya Adi",
      "Dita Prayitno Putri",
      "Fadilah Rasetyani",
      "Komari",
      "Lingga Sundagumilar Abqari",
      "Suprawoto",
      "Vincentia Christinna Puspitasari",
      "Yuliana Safitri",
    ],
  },
  {
    slug: "tata-usaha",
    label: "Tata Usaha",
    names: [
      "Yudianto Wicaksono",
      "Abraham Hanif",
      "As'ari",
      "Christina Chandra Dewi",
      "Febrianti Dwi Setiawati",
      "Hning Ramadhana Setyono",
      "I Gusti Ngurah Agung Surya Kencana",
      "Indira Maharani Putri",
      "Ivan Rovian",
      "Kamid",
      "Miftachul Arifin",
      "Mochamad Arifin",
      "Pebri Susanti",
      "Resa Bayu Anggriawan",
      "Syaiful Arifin",
      "Tri Yani",
      "Unna Wati",
      "Vicky Hari Djatmiko",
      "Wahyu Amri Yahya",
      "Yesita Eka Rakhmannia",
      "Yovhan Firdiansyah",
      "Zaenal Abidin",
      "Eko Juli Kusumawardana",
    ],
  },
  {
    slug: "sistem-informasi",
    label: "Sistem Informasi",
    names: [
      "Thohari",
      "Ario Baskoro",
      "Dyah Retno Ayu Pramita",
      "Eva Meilia",
      "Mayangsari Dwi Mahanani",
      "Novita Cahya Agustin",
      "Rachma Tistasari",
      "Tony Sugianto",
      "Vita Oktaviyanti",
      "Ganis Larasati",
    ],
  },
  {
    slug: "sumber-daya-perguruan-tinggi",
    label: "Sumber Daya Perguruan Tinggi",
    names: [
      "Indera Zainul Muttaqien",
      "Arfiono Junaedi",
      "Cindy Charisma Satriyo",
      "Erni Puspitasari",
      "Ony Ichsandrya",
      "Raden Cindy Noviyanda",
      "R.dinar Prakasa Ferdiant",
      "Winda Wahyu Prasetyaningtyas",
    ],
  },
  {
    slug: "dosen-pns-dpk",
    label: "Dosen PNS Dpk",
    names: [
      "Dyah Sawitri",
      "Abd Basit",
      "Abdul Aziz Alimul Hidayat",
      "Abdul Kadir Rahardjanto",
      "Abdul Karim",
      "Abdul Malik",
      "Abdul Rokhim",
      "Achmadi Susilo",
      "Achmad Syaichu",
      "Adhi Muhtadi",
      "Adi Sucipto",
      "Adi Sutanto",
      "Agung Nilogiri",
      "Agus Budianto",
      "Agus Budi Santosa",
      "Agus Prianto",
      "Agus Tinus",
      "Agus Wardhono",
      "Agus Widodo",
      "Ahmad Juanda Ak",
      "Ahmad Lani",
      "Ahmad Mubin",
      "Ahmad Wahyudin",
      "A'im Matun Nadhiroh",
      "Ainur Rofieq",
      "Ajang Budiman",
      "Akhmad Qomaru Zaman",
      "Akhmad Tabrani",
      "Alfiana",
      "Ali Akbar",
      "Ali Badar",
      "Ali Ikhwan",
      "Ali Nuke Affandy",
      "Amanah Agustin",
      "Amiartuti Kusmaningtyas Sh Ny",
      "Amir Hamzah",
      "Amirullah",
      "Amri Gunasti",
      "Anang Kukuh Adisusilo",
      "Anas Tain",
      "Anas Tamsuri",
      "Andaryati",
      "Andina Mayangsari",
      "Andriani Eko Prihatiningrum",
      "Andri Pitoyo",
      "Andy Kristafi Arifianto",
      "Anis Ibrahim",
      "Anis Murniati",
      "Anis Satus Syarifah",
      "Anis Sholihah",
      "Anis Yusrotun Nadhiroh",
      "Anitarakhmi Handaratri",
      "Anjisman",
      "Antonius A.prayitno S",
      "HI Anwar",
      "Anwar Hariyono",
      "Ardianik",
      "Ari Eko Wardoyo",
      "Arie Restu Wardhani",
      "Aries Iskandar",
      "Arif Budi Wurianto",
      "Ari Firmanto",
      "Arif Unwanullah",
      "Arif Wijaya",
      "Arif Winarno",
      "Arijo Isnoer Narjono",
      "Arin Wildani",
      "Ari Purwadi",
      "Aris Soelistyo",
      "Aris Winaya",
      "Arisyahidin",
      "Arya Brahmanta",
      "Asep Nurjaman",
      "Asmuji",
      "Asri Rejeki",
      "Asri Wijayanti",
      "Atik Krusiyati",
      "Auditya Purwandini Sutarto",
      "Awang Setiawan Wicaksono",
      "Awan Uji Krismanto",
      "Awatiful Azza",
      "Ayu Chandra Kartika Fitri",
      "Ayudya Mahendaringratry",
      "A Zainul Arifin",
      "Bagus Tripama",
      "Baiduri",
      "Bambang Amir Alhakim",
      "Bambang Gunawan",
      "Bambang Harmanto",
      "Bambang Hermanto",
      "Bambang Nurdewanto",
      "Bambang Purwahyudi",
      "Bambang Raditya Purnomo",
      "Bambang Tri Kurnianto",
      "Bambang Widagdo",
      "Bambang Winarto",
      "Bayu Dwi Widdy Jatmiko",
      "Bejo Suroso",
      "Bekti Prihatiningsih",
      "Benedictus Sonny Yoedono",
      "Betty Dewi Puspasari",
      "Bibit Lilik Lestari",
      "Bramantijo",
      "Budhi Priyanto",
      "Budi Iriani Yudaningrum",
      "Budiono",
      "Budi Parmono",
      "Budi Rianto",
      "Budi Utomo",
      "Budiyanto",
      "Burhan Bungin",
      "Candra Aeni",
      "Candra Hadi Asmara",
      "Candra Rini Hasanah Putri",
      "Catur Wido Haruni",
      "Choirul Huda",
      "Christina Innocenti Tumiar Panggabean",
      "Cicik Herlina Yulianti",
      "Damat",
      "Dani Yuniawan",
      "Darmadji",
      "Daroe Iswatiningsih",
      "Daryono",
      "David Hermawan",
      "Deden Faturohman",
      "Dede Nuraida",
      "Dedy Kunhadi",
      "Dendy Eta Mirlana",
      "Deny Andesta",
      "Devi Rahmayanti",
      "Dewi Ilma Antawati",
      "Dewi Setyowati",
      "Dhamas Mega Amarlita",
      "Diah Arifah Prastiningtiyas",
      "Diah Hermayanti",
      "Diah Karunia Binawati",
      "Diah Puji Nali Brata",
      "Diana Evawati",
      "Diana Isnaeni",
      "Diana Savitri Hidayati",
      "Dian Indratmi",
      "Dian Mulawarmanti",
      "Dian Noorvy Khaerudin",
      "Dian Trihastuti",
      "Dies Nurhayati",
      "Dina Novita",
      "Diyan Indriyani",
      "Djoko Apriono",
      "Dr. Ir Maftuchah, M.p.",
      "Dumiyati",
      "Dwi Ana Anggorowati",
      "Dwiati Marsiwi",
      "Dwie Retna Suryaningsih",
      "Dwi Ima Herminingsih",
      "Dwi Poedjiastutie",
      "Dwi Priyo Utomo",
      "Dwi Setiono",
      "Dwi Susilowati",
      "Dyah Prapti Wahyuni",
      "Dyah Werdiningsih",
      "Ec. Slamet Riyadi",
      "Eddy Hermanto",
      "Eddy Wasito",
      "Eding Iskak Imananto",
      "Edyson",
      "Effy Wardati Maryam",
      "Ekarini Saraswati",
      "Ekbal Santoso",
      "Eko Budi Santoso",
      "Eko Handayanto",
      "Eko Listiwikono",
      "Eko Marhaeniyanto",
      "Eko Susetyarini",
      "Elfi Anis Saati",
      "Elik Murni Ningstias Ningsih",
      "Elis Irmayanti",
      "Elly Lestari",
      "Ellys Kumala Pramartaningthyas",
      "Elly Yuniar Nitawati",
      "Emma Budi Sulistiarini",
      "Emmy Hamidah",
      "Endah Andayani",
      "Endah Nur Tjendani",
      "Endah Wahjuningsih",
      "Endang Sumarti",
      "Endang Sungkawati",
      "Endang Suprihatin",
      "Endang Suswati",
      "Enny Rachmawati",
      "Eny Masruroh, S.kep., M.kep.",
      "Erida Herlina",
      "Erika Eka Santi",
      "Erly Wahyuni",
      "Erna Hayati",
      "Erna Hendrawati",
      "Ernani Hadiyati",
      "Erwin Rommel",
      "Estu Widodo",
      "Etty Andiastuti",
      "Eva Wany",
      "Evi Hanizar",
      "Evi Nurifah Julitasari",
      "Evi Yuliawati",
      "Fahmi Poernamawatie",
      "Fajar Rakhmanto",
      "Farah Adiba",
      "Farida",
      "Faridah",
      "Fathurrahman",
      "Fatimah Nursandi",
      "Fauziyah",
      "Fefi Nurdiana Widjayanti",
      "Fifik Wiryani",
      "Firdaus Indrajaya Tuharea",
      "Firman",
      "Fitriana Minggani",
      "Gangga Anuraga",
      "Gatot Sarmidi",
      "Gatut Priyowidodo",
      "Gempur Santoso",
      "Gendut Budiwahyono",
      "Gigit Mujianto",
      "Gumoyo Mumpuni Ningsih",
      "Gunadi",
      "Gusti Adriansyah",
      "Hadiah Fitriyah",
      "Hadi Sumarsono",
      "Hadi Sutrisno",
      "Hadi Wardoyo",
      "Hairus Saleh",
      "Halimatus Sakdiyah",
      "Hanafi",
      "Handayani",
      "Harimbi Setyawati",
      "Haris",
      "Hari Soeseno Hardjoloekito",
      "Hari Sunaryo",
      "Hari Windu Asrini",
      "Hariyadi",
      "Hariyono",
      "Harliwanti Prisilia",
      "Hasan Basri",
      "Hasan Nidlom",
      "Hawin Nurdiana",
      "Hayati",
      "Hendarto Cahyono",
      "Henny Purwanti",
      "Henri Fatkurochman",
      "Heny Sulistyoningrum",
      "Heri Sujatmiko",
      "Heri Widodo",
      "Heri Wijayanto",
      "Herma Setiasih",
      "Hermin Istiasih",
      "Hery Setyobudiarso",
      "Hibertus Sujiantoro",
      "Hindarto",
      "Hudaini Hasbi",
      "Ibnu Mahmudi",
      "Ibnu Subarkah",
      "Ida Aju Brahmasari",
      "Ida Kusnawati Tjahjani",
      "Ida Nuraini",
      "Ida Sukowati",
      "Idha Zuhroh",
      "I Gusti Ayu Sri Deviyanti",
      "Iin Ervina",
      "Iin Hindun",
      "Ketut Suastika",
      "Made Kastiawan",
      "Made Suparta",
      "I Made Wartana",
      "Imam Baidlowi",
      "Imam Ropii",
      "Imam Sujono",
      "Imas Cintamulya",
      "Imbang Dwi Rahayu",
      "Indah Kurniawati",
      "Indah Nurhayati",
      "Indah Prihartini",
      "Indah Rakhmawati Afrida",
      "Indra Setiawan",
      "Indrati Rini",
      "Indriastuti",
      "Insana Meliya Dwi Cipta Aprila Sari",
      "Irany Windhyastiti",
      "Irma Sahvitri Lawado",
      "Irrine Budi Sulistiawati",
      "Irwani",
      "Iskandar",
      "Ismanto Hadi Santoso",
      "Isro ani Widayati",
      "Istiyono Kirno Prasetyo",
      "Istiyo Winarno",
      "I Wayan Letreng",
      "I Wayan Sama",
      "Jabal Tarik Ibrahim",
      "Jahju Hartanti",
      "Jati Nugroho",
      "Johan Paing Heru Waskito",
      "Joko Prasetyo",
      "Joko Purdiyanto",
      "Joseph Dedy Irawan",
      "Jozua Ferjanus Palandi",
      "Juariyah",
      "Judi Suharsono",
      "Junaidi",
      "Junarti",
      "Kadeni",
      "Kahar Haerah",
      "Kartika Ishartadiati",
      "Kasnadi",
      "Kgs Ahmadi",
      "Khoerul Anwar",
      "Khoirul Anwar",
      "Kiyono",
      "Krishno Hadi",
      "Kristanti Parishni",
      "Kristyan Dwijosusilo",
      "Kukuh Munandar",
      "Kurnia",
      "Kustiawati Ningsih",
      "Kustyarini",
      "Leni Vitasari",
      "Leo Willyanto Santoso",
      "Lilik Sri Hariani",
      "Lilis Lestari",
      "Lili Zalizar Ms",
      "Lina Listiana",
      "Lince Markis",
      "Linda Rochyani",
      "Liosten Rianna Roosida Ully Tampubolon",
      "Listiari Hendraningsih",
      "Loesita Sari",
      "Lud Waluyo",
      "HI Lukas Susanto",
      "I Lukman Hakim",
      "Luluk Sri Agus Prasetyoningsih",
      "Lusi Zafriana",
      "Made Warka",
      "Maheni Ika Sari",
      "Manah Tarman",
      "M Anas",
      "Manik Ayu Titisari",
      "Mardi Widodo",
      "Marhan Taufik",
      "Marianus Subandowo",
      "Marmi",
      "Ma'ruf Sya'ban",
      "Marwan",
      "Masduki",
      "Mas'ulah",
      "Maylita Hasyim",
      "M Chasrun H",
      "Meddy Setiawan",
      "Mei Indrawati",
      "Meinar Nur Ashrin",
      "Melanny Methasari",
      "Mercy Irene Christine Siregar",
      "Mety Liesdiani",
      "M Hazmi",
      "Miftahul Munir",
      "Mikael Adri Budi Sulistyo",
      "Miranu Triantoro",
      "Misbah",
      "Mochamad Aleq Sander",
      "Mochamad Fadil Djamali",
      "Mochamad Muchson",
      "Moch Anshori",
      "Moch.muarifin",
      "Moehammad Nasri Abdoel Wahid",
      "Moersito Wimbo Wibowo",
      "Moh Agung Surianto",
      "Mohamad Djaelani",
      "Mohamad Fatih",
      "Mohamad Syahri",
      "Mohammad Ghozi",
      "Mohammad Imsin",
      "Mohammad Mas'ud Said",
      "Mohammad Thamrin",
      "Moh Ardani",
      "Moh. Arif Bakhtiar Efendi",
      "Moh Jufri",
      "Moh Muhibbin",
      "Moh. Saifudin",
      "Mokh Hariyadi Eko Romadon",
      "M Ridlwan",
      "Mu'ah",
      "Muarrofah",
      "Muhamad Naely Azhad",
      "Muhammad Agus Sahbana",
      "Muhammad Agus Syukron",
      "Muhammad Farid Wadjdi",
      "Muhammad Firdaus",
      "Muhammad Hanif",
      "Muhammad Rofiq",
      "Muheriono",
      "Muhidin",
      "Muh Iman",
      "Muh Jufri Ahmad",
      "Muh Sui",
      "Muhtar",
      "Muh Taufiqurrohman",
      "Mukarom",
      "Mulyadi",
      "Mulyono",
      "Mumun Nurmilawati",
      "Munaji",
      "Munawaroh",
      "Mundakir",
      "Murpin Josua",
      "Muslimin",
      "Musriha",
      "Musyaffa Rafiqie",
      "Nandi Saefurrohman",
      "Nanik Lutfiyah",
      "Nanik Sri Setyani",
      "Nanis Hairunisya",
      "Nazaruddin Malik",
      "Nazharuddin Mas",
      "Nekhasius Agus Sunarjanto",
      "Nely Ana Mufarida",
      "Nersiwad",
      "Niken Lestarini",
      "Nikmatur Rohmah",
      "Ni Luh Dewi Aryani",
      "Ninik Catur Endah Yuliati",
      "Ninik Srijani",
      "Ninik Sudarwati",
      "Nirmalasari Idha Wijaya",
      "Ni Wayan Suarniati",
      "Noengki Prameswari",
      "Noor Aziz",
      "Noor Fatimah Mediawati",
      "Noor Harini",
      "Norman Duma Sitinjak",
      "Nour Athiroh Abdoes Sjakoer",
      "Nova Risdiyanto Ismail",
      "Novi Eurika",
      "Nugroho Mardi Wibowo",
      "Nugroho Tri Waskitho",
      "Nuhman",
      "Nur Aini S",
      "Nur Azizah Affandy",
      "Nur Chasanah",
      "Nurcholis Sunuyeko",
      "Nur Ida Iriani",
      "Nur Iffah",
      "Nurlaela Widyarini",
      "Nurmala Hindun",
      "Nursalim",
      "Nurul'ain",
      "Nurul Badriyah",
      "Nurul Hidayati",
      "Nurul Mahmudati",
      "Nurul Muddarisna",
      "Nurul Saila",
      "Nurul Zuriah",
      "Nurus Sobakh",
      "Nurwantari",
      "Nurwiani",
      "Nurwidodo",
      "Nur Yanu Nugroho",
      "Nusa Sebayang",
      "Nyoman Puspa Asri",
      "Nyoman Sri Widari",
      "Oktarina",
      "Oman Sukmana",
      "Ong Andre Wahju Rijanto",
      "Panca Kursistin Handayani",
      "Parji",
      "HI Pawiono",
      "Peni Suharti",
      "Pertiwi Febriana Chandrawati",
      "Pindo Tutuko",
      "Pipit Festi Wiliyanarti",
      "Poncojari Wahyono",
      "Pramukhtio Suryokencono",
      "Prantasi Harmi Tjahjanti",
      "Prasetijo Rijadi",
      "Pujo Priyono",
      "Pungut",
      "Purnawan Dwikora Negara",
      "Purwandari",
      "Purwiyanto",
      "Qomarudin",
      "Rachmat Firdaus",
      "Rahaju Saraswati",
      "Rahayu Hartini",
      "Rahayu Pujiastuti",
      "Rahayu Relawati",
      "Rahmad",
      "Rahmad Jumadi",
      "Rahmad Wijaya",
      "Rahmanta Setiahadi",
      "Rahutami",
      "Rahyu Setiani",
      "Ratih Juliati",
      "Ratna Djuniwati Lismaningsih",
      "Ratna Hartayu",
      "Ratna Mustika Wardhani",
      "Ratnaningsih",
      "Ratna Nurdiana",
      "Retno Ayu Dewi Novitawati",
      "Ribut Wahyu Eriyanti",
      "Rica Sih Wuryaningrum",
      "Rima Parwati Sari",
      "Ririen Prihandarini",
      "Ririn Probowati",
      "Ristika Handarini",
      "Rita Alfin",
      "Rochmad Haryadi",
      "Rochsun",
      "Rofi Budi Hamduwibawa",
      "Rohmad Widodo",
      "Rohmat Djoko Prakosa",
      "Rois Arifin",
      "Rokhyanto",
      "Rosyid Kholilur Rohman",
      "Rr Adiati Trihastuti Ak",
      "Rr Forijati",
      "Rr Nugrahini Susantinah Wisnujati",
      "Rudy Joegijantoro",
      "Ruslan Hidayat",
      "Rusnani",
      "Rusno",
      "Ruspeni Daesusi",
      "Said Salim Dahda",
      "Saifuddin Zuhri",
      "Saiman",
      "Samin",
      "Santika Rontika Hadi",
      "Saptya Prawitasari",
      "Sardulo Gembong",
      "Sarwo Edy",
      "Sayyida",
      "Sestu Retno Dwi Andayani",
      "Shafiq Nurdin",
      "Shofiyatul Asmi",
      "Sholikhan",
      "Sigit Budi Santoso",
      "Sigit Hermawan",
      "Sirajuddin",
      "Siti Aisyah",
      "Siti Asiyah",
      "Siti Asmaniyah Mardiyani",
      "Siti Chamidah",
      "Siti Istikhoroh",
      "Siti Maimunah",
      "Siti Munifah",
      "Siti Nur'aini",
      "Siti Nur Husnul Yusmiati",
      "Siti Zaenab",
      "Siti Zuhroh",
      "Slamet Asari",
      "Slamet Junaidi",
      "Soffiana Agustin",
      "Soni Harsono",
      "Sri Ayu Astuti",
      "Sri Hastuti",
      "Sri Purwanti",
      "Sri Rahaju Djatimurti Rita Hanafie",
      "Sri Rahayu",
      "Sri Susilowati",
      "Sri Wahyuni",
      "Sri Widyastuti",
      "Sri Yanuarsih",
      "Stefanus Budy Widjaja Subali",
      "Subangun",
      "Sudarjo",
      "Sudarmiani",
      "Sudarno",
      "Sudarti",
      "Sudi Dul Aji",
      "Sudiran",
      "Sudiyono",
      "Sudjalil",
      "Sugiono",
      "Sugito",
      "Suhari",
      "Suharto",
      "Suherman",
      "Sujarno",
      "Sujiran",
      "Sujono",
      "Sukardi",
      "Sukarjati",
      "Sukarsono",
      "Sukisno",
      "Sulastri Rini Rindrayani",
      "Sulistio Adiwinarto",
      "Sulistiono",
      "Sulistyani Eka Lestari",
      "Sulistyo",
      "Sulton",
      "Sumadi",
      "Sumaji",
      "Sumani",
      "Sumarji",
      "Sumiarjo Kiswondo",
      "Sunarno",
      "Sunarto",
      "Sunyoto Hadi Prayitno",
      "Supiana Dian Nurtjahyani",
      "Suprianto",
      "Suprihana",
      "Supri Wahyudi Utomo",
      "Supriyadi",
      "Supriyo",
      "Surahmat",
      "Surjo Hadi",
      "Survival",
      "Surya Anoraga",
      "Suryadhi",
      "Suryaningsih",
      "Suryo Widodo",
      "Susana Ristiarini",
      "Susintowati",
      "Sutawi",
      "Sutejo",
      "Suwadi",
      "Suwardi",
      "Suwarno",
      "Suyanto",
      "Suyatno",
      "Suyono",
      "Syamsudduha Syahrorini",
      "Syamsul Ghufron",
      "Syamsulina Revianti",
      "Syarif Husen",
      "Tabitha Sri Hartati W",
      "Takim Mulyanto",
      "Tamriatin Hidayah",
      "Tarsisius Dwi Wibawa Budianta",
      "Tatang Sopandi",
      "Tatuk Tojibatus Sa'adah",
      "Taufikkurrahman",
      "Taufik Rachman",
      "Teja Insyaf Sukariyadi",
      "Titiek Sunaryati",
      "Titik Juwariah",
      "Titik Purwati",
      "Titi Rapini Se",
      "Titis Srimurni",
      "Tjetjep Yusuf Afandi",
      "Tongat",
      "Totok Dwi Kuryanto",
      "Totok Hari Prasetiyo",
      "Totok Hendarto",
      "Totok Priyoleksono",
      "Toto Suharjanto",
      "Triana Kartika Santi",
      "Tri Andjarwati",
      "Tri Marhaeni Widiastuti",
      "Tri Muji Ingarianti",
      "Trinil Windrowati",
      "Tri Sulistyaningsih",
      "Triuli Novianti",
      "Tri Wardoyo",
      "Triyonowati",
      "Tutik Heriana",
      "Uci Yuliati",
      "Ujang Rohman",
      "Umaimah",
      "Umi Hidayati",
      "Umi Kalsum",
      "Umi Muawanah",
      "Umu Khouroh",
      "Untung Santoso",
      "Usep Supriatna",
      "Utami Puji Lestari",
      "Uzlifatul Masruroh Isnawati",
      "Vera Septi Andrini",
      "Vieta Imelda Coernelis",
      "VT Suharto",
      "Wachidatus Sa'adah",
      "Wadji",
      "Wahid Hidayat",
      "Wahyudiyanto",
      "Wahyu Prihanta",
      "Wahyu Sri Astutik",
      "Waras",
      "Wardah",
      "Waris",
      "Warkoyo",
      "Warli",
      "Warsono",
      "Widhy Wahyani",
      "Widodo",
      "Widowati",
      "Widyana Rahmatika",
      "Widyasri Prananingrum",
      "Widyastuti",
      "Wikanso",
      "Wimba Respatia",
      "Winasis Yulianto",
      "Wisnu Panggah Setiyono",
      "Wiwik Prihartanti",
      "Wiwik Suharso",
      "Wiwin Sri Hidayati",
      "Wiwit Widiarti",
      "Wiwi Wikanta",
      "Woro Utari",
      "Wulandari Harjanti",
      "Yarno",
      "Yasip",
      "Yekti Herlina",
      "Yekti Sri Rahayu",
      "Yenywaty Simamora",
      "Yoifah Rizka Wendarti",
      "Yosi Kristian",
      "Yudhi Arifani",
      "Yudi Supiyanto",
      "Yulita Pujiharti",
      "Yunia Dwie Nurcahyanie",
      "Yuni Agung Nugroho",
      "Yuniep Mujati Suaidah",
      "Yuniorita Indah Handayani",
      "Yuni Pantiwati",
      "Yupono Bagyo",
      "Yus Mochamad Cholily",
      "Yusrudin",
      "Zainal Abidin",
      "Zainal Afandi",
      "Zainal Arifin",
      "Zainol Arifin",
      "Zainun",
      "Zainur Rozikin",
      "Zauhani Kusnul H",
      "Zulkarnain",
      "Zulkifli Lubis",
      "Zumrotus Sya'diyah",
    ],
  },
];
